<script setup lang="ts">
// ================================
// IMPORTS
// ================================
</script>

<template>
    <!-- ================================ -->
    <!-- COMPOSANT PRINCIPAL -->
    <!-- ================================ -->
    <div class="page-not-found">
        <BaseCard class="page-not-found__card">
            <template #title>
                <h2 class="text-semibold">Page Introuvable !</h2>
            </template>
            <template #content>
                <p>Oops! La page que vous recherchez n'existe pas.</p>
            </template>
        </BaseCard>
    </div>
</template>

<style scoped>
/* ================================ */
/* COMPOSANT PRINCIPAL */
/* ================================ */
.page-not-found {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f4f4f4;
    text-align: center;
}

.page-not-found__card {
    max-width: 400px;
    padding: 2rem;
}
</style>
